import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

export default function NoticeAlertBar() {
  const [notice, setNotice] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api("/api/notices")
      .then((items) => {
        if (!Array.isArray(items)) return;
        const top = items.find((item) => item.priority === "urgent") || items.find((item) => item.is_featured) || null;
        setNotice(top);
      })
      .catch(() => {});
  }, []);

  if (!notice || dismissed) return null;

  return (
    <div className="fpb-notice-alert sticky top-0 z-50 bg-red-700 px-3 py-3 text-white shadow-lg sm:px-4">
      <div className="fpb-notice-alert-inner mx-auto flex max-w-7xl flex-wrap items-center gap-2 text-sm font-bold md:justify-between">
        <Link to={`/notice-board/${notice.slug}`} className="fpb-notice-alert-link min-w-0 flex flex-1 items-center gap-2 hover:underline">
          <span className="fpb-notice-alert-badge flex-shrink-0 rounded-full bg-white/20 px-2 py-1 text-xs uppercase tracking-wide">{notice.priority}</span>
          <span className="fpb-notice-alert-title min-w-0 truncate">{notice.title}</span>
        </Link>
        <button onClick={() => setDismissed(true)} className="fpb-notice-alert-dismiss flex-shrink-0 rounded-lg bg-white/15 px-3 py-1 text-xs font-black hover:bg-white/25" aria-label="Dismiss notice alert">
          Dismiss
        </button>
      </div>
    </div>
  );
}
